import { setup } from "web/entrypoints/common/setup";
import FiveXX from "web/react/pages/error/5xx/5xx";
import renderReactComponentInDocument from "web/script/utils/render-react";
import "./css-error";
import components from "./react-error";

// attach browser rendered components
const container = document.querySelector("#fivexx-container");
if (container) {
    renderReactComponentInDocument(FiveXX, {}, container);
}

setup(components);
